import type { NotificationItemComponent } from "./NotificationItem";

import React from "react";
import { useNavigate } from "@tanstack/react-router";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button } from "@mui/material";

import NotificationItem from "./NotificationItem";
import useRecommended from "@/components/subscription/customize/hooks/useRecommended";
import useCustomizeQuery from "@/components/newcustomize/hooks/useCustomizeQuery";
import { PlanIdTypeSafe } from "@/types/PlanTypes";
import usePlan from "@/hooks/usePlan";

const OptimizeProxyCount = ({ planId }: { planId?: PlanIdTypeSafe }) => {
  const { data: plan } = usePlan(planId || "default");
  if (!plan) {
    return (
      <Box component="span">
        Adding more proxies, you can improve your proxy’s performance.
      </Box>
    );
  }
  return (
    <Box>
      You have{" "}
      {plan && plan.bandwidth_limit > 0
        ? `${plan.bandwidth_limit.toLocaleString()}  GB `
        : "Unlimited bandwidth "}
      bandwidth in your plan and it’s not utilized yet. By adding more proxies,
      you can improve your proxy’s performance.
    </Box>
  );
};

const TooMuchBandwidthTooLittleProxies: NotificationItemComponent = ({
  item,
}) => {
  const navigate = useNavigate();
  const { proxyCount } = useRecommended({ planId: item.context?.plan });

  const { link: customizeHref } = useCustomizeQuery({
    source: "notification",
    showCustomizeSections: ["proxy-count"],
    ...proxyCount,
    existingPlanId: item.context?.plan,
  });

  const handleOptimize = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    void navigate({ ...customizeHref, replace: true });
  };

  return (
    <NotificationItem variant={!item.dismissed_at ? "primary" : "default"}>
      <NotificationItem.Title created_at={item.created_at}>
        <span>Optimize proxy count</span>
      </NotificationItem.Title>
      <NotificationItem.Content>
        <OptimizeProxyCount planId={item.context?.plan} />
      </NotificationItem.Content>
      <NotificationItem.Actions {...item}>
        <Button
          onClick={handleOptimize}
          size="small"
          variant={!item.dismissed_at ? "contained" : "outlined"}
          color="primary"
          disableElevation
          endIcon={<OpenInNewIcon fontSize="small" />}
        >
          Optimize
        </Button>
      </NotificationItem.Actions>
    </NotificationItem>
  );
};

export default TooMuchBandwidthTooLittleProxies;
